import { render } from "./ProcessesCreate.vue?vue&type=template&id=955e36fa&scoped=true"
import script from "./ProcessesCreate.vue?vue&type=script&lang=js"
export * from "./ProcessesCreate.vue?vue&type=script&lang=js"

import "./ProcessesCreate.vue?vue&type=style&index=0&id=955e36fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955e36fa"]])

export default __exports__